import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import PrepareTrackingDataHelper from '@Services/PrepareTrackingDataHelper';
import { Icon } from '@els/els-react--icon';

function ToggleButton({
  className,
  ariaControls,
  expanded,
  toggleExpand,
  expandedLabel,
  collapsedLabel,
  prepareTrackingData,
  dataTrackingAction,
  isViewPreview,
}) {
  const getBtnClasses = () => classnames([className, 'els-btn', 'els-btn-link', 'els-btn-right']);

  const getTrackingAttrs = () =>
    prepareTrackingData
      ? {
          'data-click-delegation': 'true',
          'data-tracking': expanded,
          'data-tracking-context': 'reactions',
          'data-tracking-preview': isViewPreview,
          'data-tracking-type': 'contentview,contentlinkclick',
          'data-tracking-action': dataTrackingAction,
          ...PrepareTrackingDataHelper.prepare(prepareTrackingData),
        }
      : {};

  return (
    // eslint-disable-next-line react/button-has-type
    <button
      className={getBtnClasses()}
      aria-controls={ariaControls}
      aria-expanded={expanded}
      onClick={() => toggleExpand()}
      {...getTrackingAttrs()}>
      <span>{expanded ? expandedLabel : collapsedLabel}</span>
      <Icon sprite={expanded ? 'ChevronUp' : 'ChevronDown'} size="xs" className="rx-border-none">
        {expanded ? expandedLabel : collapsedLabel}
      </Icon>
    </button>
  );
}

ToggleButton.propTypes = {
  className: PropTypes.string,
  ariaControls: PropTypes.string.isRequired,
  expanded: PropTypes.bool.isRequired,
  toggleExpand: PropTypes.func.isRequired,
  expandedLabel: PropTypes.string.isRequired,
  collapsedLabel: PropTypes.string.isRequired,
  prepareTrackingData: PropTypes.object,
  dataTrackingAction: PropTypes.string,
  isViewPreview: PropTypes.bool,
};

export default ToggleButton;
